import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { API } from "../../api/services";
import { ToastMessage } from "../../helpers/ToastMessage";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../redux/features";
import {
  fetchProfileDetails,
  setProfileState,
} from "../../redux/features/profile/profileSlice";
import CommonSetting from "../../components/common/CommonSetting";
import { setAppState } from "../../redux/features/appStateSlice";
import { Helmet } from "react-helmet-async";

const SettingsPage = () => {
  const [open, setOpen] = useState(false);
  const [switchState, setSwitchState] = useState({
    notification: false,
    promotional: false,
    isProfileVisible: false,
  });

  const { profileData } = useSelector((state: any) => state?.profile);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [token] = useCookies();

  useEffect(() => {
    dispatch(setAppState("settings"));
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    const getProfileData = async () => {
      dispatch(setLoading(true));
      const res = await dispatch(fetchProfileDetails());
      setTimeout(() => {
        const data = res?.payload;
        dispatch(setProfileState(res?.payload));
        setSwitchState({
          notification: data?.email_notification,
          promotional: data?.promotional_notification,
          isProfileVisible: data?.is_profile_visible,
        });
        dispatch(setLoading(false));
      }, 100);
    };
    getProfileData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [_, __, removeAccessTokenToken] = useCookies([
    "accessToken",
    "refreshToken",
    "googleToken",
    "role",
  ]);
  const handleDelete = async () => {
    try {
      dispatch(setLoading(true));
      const res = await API.get("/delete-account");
      if (res.data.status) {
        // Remove cookies
        removeAccessTokenToken("accessToken", { path: "/" });
        removeAccessTokenToken("refreshToken", { path: "/" });
        removeAccessTokenToken("googleToken", { path: "/" });
        removeAccessTokenToken("role", { path: "/" });

        // Remove from localStorage
        localStorage.removeItem("login");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("googleToken");
        localStorage.removeItem("role");
        localStorage.removeItem("accessToken_expiry");
        localStorage.removeItem("refreshToken_expiry");
        localStorage.removeItem("googleToken_expiry");
        localStorage.removeItem("role_expiry");

        // Remove from sessionStorage
        sessionStorage.removeItem("login");
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("refreshToken");
        sessionStorage.removeItem("googleToken");
        sessionStorage.removeItem("role");
        sessionStorage.removeItem("accessToken_expiry");
        sessionStorage.removeItem("refreshToken_expiry");
        sessionStorage.removeItem("googleToken_expiry");
        sessionStorage.removeItem("role_expiry");

        ToastMessage({
          type: "success",
          message: res.data.message,
        });
      }
      dispatch(setLoading(false));
      if (res.message === "Unauthenticated") {
        // Remove cookies
        removeAccessTokenToken("accessToken", { path: "/" });
        removeAccessTokenToken("refreshToken", { path: "/" });
        removeAccessTokenToken("googleToken", { path: "/" });
        removeAccessTokenToken("role", { path: "/" });

        // Remove from localStorage
        localStorage.removeItem("login");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("googleToken");
        localStorage.removeItem("role");
        localStorage.removeItem("accessToken_expiry");
        localStorage.removeItem("refreshToken_expiry");
        localStorage.removeItem("googleToken_expiry");
        localStorage.removeItem("role_expiry");

        // Remove from sessionStorage
        sessionStorage.removeItem("login");
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("refreshToken");
        sessionStorage.removeItem("googleToken");
        sessionStorage.removeItem("role");
        sessionStorage.removeItem("accessToken_expiry");
        sessionStorage.removeItem("refreshToken_expiry");
        sessionStorage.removeItem("googleToken_expiry");
        sessionStorage.removeItem("role_expiry");
      }
    } catch (error: any) {
      if (error?.message === "Unauthenticated") {
        // Remove cookies
        removeAccessTokenToken("accessToken", { path: "/" });
        removeAccessTokenToken("refreshToken", { path: "/" });
        removeAccessTokenToken("googleToken", { path: "/" });
        removeAccessTokenToken("role", { path: "/" });

        // Remove from localStorage
        localStorage.removeItem("login");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("googleToken");
        localStorage.removeItem("role");
        localStorage.removeItem("accessToken_expiry");
        localStorage.removeItem("refreshToken_expiry");
        localStorage.removeItem("googleToken_expiry");
        localStorage.removeItem("role_expiry");

        // Remove from sessionStorage
        sessionStorage.removeItem("login");
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("refreshToken");
        sessionStorage.removeItem("googleToken");
        sessionStorage.removeItem("role");
        sessionStorage.removeItem("accessToken_expiry");
        sessionStorage.removeItem("refreshToken_expiry");
        sessionStorage.removeItem("googleToken_expiry");
        sessionStorage.removeItem("role_expiry");

        dispatch(setLoading(false));
      }
    }
  };

  const handleClick = async (name: any, value: any) => {
    let requst = {};

    if (name === "notification")
      requst = {
        email_notification: value === true ? 1 : 0,
        promotional_notification: profileData.promotional_notification ? 1 : 0,
        is_profile_visible: switchState.promotional ? 1 : 0,
      };

    if (name === "promotional") {
      requst = {
        email_notification: switchState?.notification ? 1 : 0,
        promotional_notification: value === true ? 1 : 0,
      };
    }

    if (name === "isProfileVisible") {
      requst = {
        email_notification: switchState?.notification ? 1 : 0,
        promotional_notification: switchState.promotional ? 1 : 0,
        is_profile_visible: value === true ? 1 : 0,
      };
    }

    dispatch(setLoading(true));
    await API.post("/setting", requst)
      .then((res: any) => {
        if (res.data.status) {
          ToastMessage({
            type: "success",
            message: res.data.message,
          });
        } else {
          ToastMessage({
            type: "error",
            message: res.data.message,
          });
        }
        dispatch(setLoading(false));
      })
      .catch((e: any) => {
        ToastMessage({
          type: "error",
          message: e.message,
        });
        dispatch(setLoading(false));
      });
  };

  const handleSwitchChange = (event: any) => {
    const name = event.target.name;
    setSwitchState({ ...switchState, [name]: event.target.checked });
    handleClick(name, event.target.checked);
  };

  const renderHelmet = () => {
    if (token.role === "2") {
      return (
        <Helmet>
          <title>
            Dashboard Settings | Customize Your Influencer Dashboard
          </title>
          <meta
            name="description"
            content="Access your QuickFluence dashboard settings to easily manage account details, refine collaboration preferences, and streamline your brand–creator workflow."
          />
          {/* Canonical */}
          <link rel="canonical" href="https://quickfluence.com/" />
          {/* Open Graph */}
          <meta
            property="og:title"
            content="QuickFluence Dashboard Settings for Influencer Control"
          />
          <meta
            property="og:description"
            content="Access your QuickFluence dashboard settings to easily manage account details, refine collaboration preferences, and streamline your brand–creator workflow."
          />
          <meta property="og:url" content="https://quickfluence.com/" />
          <meta property="og:site_name" content="quickfluence" />
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="en" />
          <meta
            property="og:image"
            content="https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png"
          />
          <meta
            property="og:image:alt"
            content="Customize your influencer dashboard settings"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      );
    } else if (token.role === "3") {
      return (
        <Helmet>
          <title>Quickly control and update your account settings</title>
          <meta
            name="description"
            content="Customize your QuickFluence account settings and notifications. Manage alerts, adjust preferences, and enhance your influencer collaboration experience."
          />
          {/* Canonical */}
          <link rel="canonical" href="https://quickfluence.com/" />
          {/* Open Graph */}
          <meta
            property="og:title"
            content="QuickFluence Account and Notification Settings Page"
          />
          <meta
            property="og:description"
            content="Customize your QuickFluence account settings and notifications. Manage alerts, adjust preferences, and enhance your influencer collaboration experience."
          />
          <meta property="og:url" content="https://quickfluence.com/" />
          <meta property="og:site_name" content="quickfluence" />
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="en" />
          <meta
            property="og:image:alt"
            content="Manage alerts and account preferences on QuickFluence"
          />
          <meta
            property="og:image"
            content="https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      );
    }
    return null; // If role is neither 2 nor 3
  };

  return (
    <>
      {renderHelmet()}
      <CommonSetting
        isInfluencer={token.role === "2" ? true : false}
        switchState={switchState}
        handleSwitchChange={(e: any) => handleSwitchChange(e)}
        navigate={navigate}
        handleClickOpen={() => {
          handleClickOpen();
        }}
        open={open}
        handleClose={() => {
          handleClose();
        }}
        handleDelete={() => {
          handleDelete();
        }}
      />
    </>
  );
};

export default SettingsPage;
